import React from 'react';

import { Helmet } from 'react-helmet-async';

import { SEO_DEFAULTS } from '../../constants';


// Keep in sync with server/render.mjs (buildHeadTags): the server writes the same tags into the HTML.
const DESCRIPTION_LIMIT = SEO_DEFAULTS.descriptionLimit;

interface MetaTagsInformation {
    title?: string;
    thumbnail?: string;
    url?: string;
    description?: string;
    type?: string;
}

interface SeoProperties {
    meta?: MetaTagsInformation
}

function Seo ({ meta }: SeoProperties) {
  const description = meta?.description && (meta.description.length > DESCRIPTION_LIMIT
    ? meta.description.slice(0, DESCRIPTION_LIMIT).trimEnd() + '...'
    : meta.description);
  const url = meta?.url ?? `${SEO_DEFAULTS.siteUrl}${window.location.pathname === '/' ? '' : window.location.pathname.replace(/\/+$/, '')}`;

  return (
    <Helmet>
        <title>{`Radio Plato | ${ meta?.title }`}</title>
        <meta property='og:title' content={ meta?.title } />
        <meta property='og:image' content={ meta?.thumbnail } />
        <meta property='og:description' content={ description } />
        { meta?.type && (<meta property='og:type' content={ meta.type } />) }
        <meta name='description' content={ description } />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={ meta?.thumbnail } />
        <meta property='og:url' content={ url } />
        <link rel='canonical' href={ url } />
        <link rel="apple-app-site-association file" href="apple-app-site-association" />
    </Helmet>
  )
}

function withSeo (meta: MetaTagsInformation, children: React.ReactNode) {
    return (
        <>
            <Seo meta={ meta }/>
            { children }
        </>
    )
}

export { Seo, withSeo };